<router-outlet #outlet="outlet"></router-outlet>

@if(env.showInstallBannerPwa && pwaManagerService.shouldShowInstall()){
<div class="install-app">
	<div class="text-icon">
		<span class="icon" (click)="pwaManagerService.dismissInstallBanner()">
			<i class="fa-regular fa-close"></i>
		</span>
		{{'APPLICATION_PWA.TEXT' | translate}}
	</div>
	<button type="submit" class="btn-tc size-sm btn-primary-new" (click)="installPWA()" mat-flat-button
		[disableRipple]="true" appMousePress>
		{{'APPLICATION_PWA.INSTALL' | translate}}
	</button>
</div>
}

@if(pwaManagerService.shouldShowUpdate()){
<div class="install-app">
	<div class="text-icon">
		{{'APPLICATION_PWA.UPDATE_VERSION' | translate}}
	</div>
	<button type="submit" class="btn-tc size-sm btn-primary-new" (click)="updateNowPWA()" mat-flat-button
		[disableRipple]="true" appMousePress>
		{{'APPLICATION_PWA.UPDATE' | translate}}
	</button>
</div>
}

@if(pwaManagerService.apkUpdateRequired()){
<div class="install-app">
	<div class="text-icon">
		{{'APPLICATION_PWA.UPDATE_VERSION' | translate}}
	</div>
	<button type="submit" class="btn-tc size-sm btn-primary-new" (click)="pwaManagerService.openApkUpdateLink()"
		mat-flat-button [disableRipple]="true" appMousePress>
		{{'APPLICATION_PWA.UPDATE' | translate}}
	</button>
</div>
}